import type { InsuranceFeatureConfig } from '../types/InsuranceFeatureConfig';
import { claimsConfig } from './configByFeature/claims';
import { dashboardConfig } from './configByFeature/dashboard';
import { fundsConfig } from './configByFeature/funds';
import { modificationsConfig } from './configByFeature/modifications';
import { servicingConfig } from './configByFeature/servicing';
import { accidentConfig } from './configByInsuranceType/accident';
import { belongingsConfig } from './configByInsuranceType/belongings';
import { flightConfig } from './configByInsuranceType/flight';
import { fundConfig } from './configByInsuranceType/fund';
import { healthConfig } from './configByInsuranceType/health';
import { lifeConfig } from './configByInsuranceType/life';
import { productConfig } from './configByInsuranceType/product';
import { propertyConfig } from './configByInsuranceType/property';
import { travelConfig } from './configByInsuranceType/travel';

export const insurances: Partial<InsuranceFeatureConfig> = {
    defaultRoute: 'overview',
    showManageInsurance: false,
    relyOnWebAPIAlias: false,
    showCurrentCapitalValue: true,
    claims: claimsConfig.HU,
    dashboard: dashboardConfig.HU,
    funds: fundsConfig.HU,
    modifications: modificationsConfig.HU,
    servicing: servicingConfig.HU,
    accident: accidentConfig.HU,
    belongings: belongingsConfig.HU,
    flight: flightConfig.HU,
    fund: fundConfig.HU,
    health: healthConfig.HU,
    life: lifeConfig.HU,
    product: productConfig.HU,
    property: propertyConfig.HU,
    travel: travelConfig.HU,
};
